import React, { useState } from "react";
import { Modal, Button, Alert, Form } from "react-bootstrap";
import './ModalConsentGate.css';
import { linkOESDGSE, linkDPImprint } from '../../Consts';


const openWindowNewSite = (site) => {
        if (site === 'dgse') {
            window.open(linkOESDGSE, '_blank');
        }
        if (site === 'imprint') {
            window.open(linkDPImprint + "imprint", '_blank');
        }
        if (site === 'dp') {
            window.open(linkDPImprint + "dp", '_blank');
        }
    }

function ModalConsentGate({ children }) {
    const [status, setStatus] = useState(null);
    const [hasReadHints, setHasReadHints] = useState(false);

    if (status === "declined") {
        return (
            // <div className="container py-5">
            //     <Alert variant="danger">
            //         <Alert.Heading>Nutzung nicht möglich</Alert.Heading>
            //         <p>
            //             Ohne Zustimmung zu den Hinweisen kann dieses Werkzeug nicht verwendet
            //             werden.
            //         </p>
            //         <p className="mb-0">
            //             Du kannst dieses Fenster nun schließen.
            //         </p>
            //     </Alert>
            // </div>
            <div className="container min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#ffffff', boxShadow: 'none', border: 'none' }}>
                <div className="col-12 col-md-8 col-lg-5">
                    <div className="card shadow border-0 rounded-4 text-center">
                        <div className="card-body p-5">
                            <div className="display-4 mb-3" aria-hidden="true">
                                🚫
                            </div>

                            <h1 className="h3 mb-3">
                                Nutzung leider nicht möglich
                            </h1>

                            <p className="text-muted mb-4">
                                Ohne Ihre Zustimmung zu den Hinweisen kann dieses Werkzeug nicht verwendet werden.
                            </p>

                            <div className="alert alert-light border mb-0">
                                Sie können dieses Browser-Tab nun manuell schließen.
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <Modal
                show={status === null}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header>
                    <Modal.Title>Wichtige Hinweise zur Nutzung</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ul>
                        <li>
                            {/* Bei der Erfassung personenbezogener Daten (Schülerdaten) sollte die Eingabe von Klarnahmen vermieden werden. Sie können 
                            beispielsweise Pseudonyme verwenden, um die Anonymität der Schüler zu gewährleisten. Sollte Sie 
                            dennoch personenbezogene Daten eingeben, stellen Sie bitte sicher, dass Sie die Daten niemand zugänglich machen und falls Sie die Daten speichern,
                            tragen Sie dafür Sorge, dass niemand unbefugt auf die Daten zugreifen kann.

                            Alle Daten, die Sie in diesem Werkzeug eingeben, werden ausschließlich lokal auf Ihrem 
                            Endgerät verarbeitet und gespeichert. Es findet keine Übertragung von Daten an externe Server oder Dritte statt. */}
                            Bei der Erfassung personenbezogener Daten, insbesondere von Schülerdaten, sollte die Eingabe von Klarnamen nach Möglichkeit vermieden werden. Verwenden Sie stattdessen beispielsweise Pseudonyme, um die Identität der Schülerinnen und Schüler zu schützen.

                            Sollten Sie dennoch personenbezogene Daten eingeben, stellen Sie bitte sicher, dass diese Daten nicht unbefugt zugänglich gemacht werden. Falls Sie die Daten speichern, achten Sie darauf, dass sie vor dem Zugriff durch Dritte angemessen geschützt sind.

                            Alle Daten, die Sie in dieses Werkzeug eingeben, werden ausschließlich lokal auf Ihrem Endgerät verarbeitet und gespeichert. Eine Übertragung an externe Server oder Dritte findet nicht statt.

                        </li>
                        <li>
                            {/* Wenn Sie die Anwendung auf einem privaten Endgerät verwenden, stellen Sie bitte sicher, dass
                            eine Genehmigung der Schulleitung nach Anlage 1 der VwV Datenschutz an öffentlichen Schulen
                            vorliegt. Bitte stellen Sie sicher, dass vor einer Nutzung des Endgeräts durch Dritte,
                            z. B. Familienangehörige, zwingend das Browser-Tab geschlossen werden muss und eventuell gespeicherte
                            Daten sicher verwahrt sind, damit kein unbefugter Zugriff auf die Daten möglich ist. */}
                            Wenn Sie die Anwendung auf einem privaten Endgerät verwenden, stellen Sie bitte sicher, dass hierfür eine Genehmigung der Schulleitung gemäß Anlage 1 der <a href="https://it.kultus-bw.de/site/pbs-bw-km-root/get/documents_E1427590149/KULTUS.Dachmandant/KULTUS/Dienststellen/it.kultus-bw/Datenschutz%20an%20Schulen%20nach%20neuer%20EU%20DSGVO/dl-rechtsgrundlagen/VwV-Datenschutz-an-oeffentlichen-Schulen%20.pdf" target="_blank" rel="noopener noreferrer">VwV Datenschutz an öffentlichen Schulen</a> vorliegt.

                            Achten Sie außerdem darauf, dass das Browser-Tab vor einer Nutzung des Endgeräts durch Dritte, zum Beispiel durch Familienangehörige, geschlossen wird. Eventuell gespeicherte Daten sind so zu verwahren, dass ein unbefugter Zugriff ausgeschlossen ist.


                        </li>

                    </ul>
                    <p>
                        Ohne Ihre Zustimmung zu den obigen Hinweisen kann das Werkzeug nicht verwendet werden.
                    </p>

                    <Form.Check className="d-flex align-items-center gap-2 mt-3 consent-check">
                        <Form.Check.Input
                            id="consent-read-hints"
                            type="checkbox"
                            checked={hasReadHints}
                            onChange={(event) => setHasReadHints(event.target.checked)}
                            className="mt-0"
                        />

                        <Form.Check.Label
                            htmlFor="consent-read-hints"
                            className="mb-0"
                        >
                            Ich habe die Hinweise gelesen, verstanden und akzeptiert.
                        </Form.Check.Label>
                    </Form.Check>

                    <p>
<span className="text-nowrap">
  Sehen Sie ferner die{" "}
  <Button
    variant="link"
    className="p-0 align-baseline"
    onClick={() => openWindowNewSite("dp")}
  >
    Datenschutzerklärung
  </Button>{" "}
  und das{" "}
  <Button
    variant="link"
    className="p-0 align-baseline"
    onClick={() => openWindowNewSite("imprint")}
  >
    Impressum
  </Button>
  .
</span>                    </p>
                </Modal.Body>

                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={() => setStatus("declined")}>
                        Nein, ich stimme nicht zu
                    </Button>

                    <Button variant="primary" onClick={() => setStatus("accepted")}>
                        Ja, ich habe die Hinweise gelesen und stimme zu
                    </Button>
                </Modal.Footer> */}
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setStatus("declined")}
                    >
                        Abbrechen
                    </Button>

                    <span
                        style={{
                            display: "inline-block",
                            cursor: hasReadHints ? "pointer" : "not-allowed"
                        }}
                    >

                        <Button
                            variant="primary"
                            disabled={!hasReadHints}
                            className="consent-accept-button"
                            onClick={() => setStatus("accepted")}
                        >
                            Bestätigen
                        </Button>
                    </span>
                </Modal.Footer>
            </Modal>

            {status === "accepted" && children}
        </>
    );
}

export default ModalConsentGate;